import React from "react";
import { Stack } from "@mui/material";

import MobilePrimaryNavigationHeader from "@/components/header/navigation/mobile/_components/primary-navigation/mobile-primary-navigation-header";
import MobilePrimaryNavigationItems from "@/components/header/navigation/mobile/_components/primary-navigation/mobile-primary-navigation-items";

import { NavigationType } from "@/components/header/common/header-enums";
import { HeaderNavProps } from "@/components/header/common/types";

import { Company } from "@/types/contentful/company";
import { Locale } from "@/i18n/routing";

type MobilePrimaryNavigationProps = {
  locale: Locale;
  currentCompany?: Company;
  headerNavProps: HeaderNavProps[];
  setSecondaryNavItems: (destination: HeaderNavProps[]) => void;
  setCurrentPrimaryNavLabel: (currentPrimaryNavLabel: string) => void;
  setActiveNavigation: (activeNavigation: NavigationType) => void;
};

export default function MobilePrimaryNavigation(props: MobilePrimaryNavigationProps) {
  const { locale, currentCompany, headerNavProps,setSecondaryNavItems, setCurrentPrimaryNavLabel, 
    setActiveNavigation} = props;  

  return (
    <Stack 
      sx={{ 
        "&.MuiStack-root.mui-nen11g-MuiStack-root": {
          position: "fixed"
        }
      }}>
      <MobilePrimaryNavigationHeader
        locale={locale}
        currentCompany={currentCompany}
        setActiveNavigation={setActiveNavigation}
      />
      <MobilePrimaryNavigationItems 
        headerNavProps={headerNavProps}
        setActiveNavigation={setActiveNavigation}
        setCurrentPrimaryNavLabel={setCurrentPrimaryNavLabel}
        setSecondaryNavItems={setSecondaryNavItems}        
      />
    </Stack>
  );
}
